<template>
  <div id="board">
    <div id="postcounter" class="postcounter">
        {{ postCount }} posts and counting!
    </div>
    <form v-on:submit="addPost($event)">
      <input
        type="text"
        placeholder="Your post goes here..."
        v-model="newPost"
        class="post-box"
        maxlength="280"
      />
      <!-- <input type="submit" value="" /> -->
    </form>
    <div class="connection-text"> Connection Status
      <img
      v-bind:class="[{'live-Stream' : isConnected}, {'dead-Stream' : !isConnected}]"
        src="../assets/red_circle_sm.png"
      />
    </div>
    <ul>
      <div
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="busy"
        infinite-scroll-distance="2000"
      >
        <transition-group name="list">
          <li v-for="post in posts" v-bind:key="post._id">
            <div class="message" v-bind:class="{ myMessage: post.myMessage }">
              {{ post.msg }}
            </div>
          </li>
        </transition-group>
      </div>
    </ul>
  </div>
</template>
<script>
import boardApi from "@/services/boardApi.js";
export default {
  data() {
    // variables and stuff accessible in this view..
    return {
      postCount: 0,
      newPost: "",
      posts: [],
      busy: false,
      lastSubmitted: 0,
      isConnected: true,
      socketMessage: ""
    };
  },
  mounted() {
    // onLoad type thing
    this.loadPosts();
    this.loadPostCount();
  },
  methods: {
    async addPost(evt) {
      evt.preventDefault(); // prevents the form's default action from redirecting the page
      if (new Date().valueOf() - this.lastSubmitted > 2000) {
        //const response = await boardApi.addPost(this.newPost);
        //this.posts.unshift(this.newPost);
        this.$socket.emit("addPost", this.newPost);
        this.newPost = ""; // clear the input field
        this.lastSubmitted = new Date().valueOf();
      } else {
        // can only post every x ms, do some animation maybe
      }
    },
    async loadPosts() {
      const response = await boardApi.getPosts();
      this.posts = response.data;
    },
    async loadPostCount() {
      const response = await boardApi.getPostCount();
      this.postCount = response.data;
    },
    loadMore() {
      this.busy = true;
      if (this.posts !== undefined && this.posts.length > 0) {
        boardApi
          .getPostsFromDate(this.posts[this.posts.length - 1].posttime)
          .then(response => {
            this.posts.push(...response.data);
          });
      }
      this.busy = false;
    }
  },
  sockets: {
    connect() {
      this.isConnected = true;
    },

    disconnect() {
      this.isConnected = false;
    },

    // Fired when the server sends something on the "newPost" channel.
    newPost(data) {
      // console.log("got message! " + JSON.stringify(data));
      // console.log("data.sessionId " + data.sessionId);
      // console.log("this.$socket.id " + this.$socket.id);
      if (data.sessionId === this.$socket.id) {
        // if the session id matches (i.e. it's their own message)
        data.myMessage = true;
      }
      this.posts.unshift(data);
      this.postCount++;
    }
  }
};
</script>

<style lang="css">
ul,
li {
  list-style: none;
  margin: 5px;
  padding: 5px;
  text-align: center;
}
li {
  text-align: center;
}
.message {
  color: var(--text-color);
  margin-left: auto;
  margin-right: auto;
  clear: both;
  line-height: 18px;
  font-size: 15px;
  padding: 8px;
  position: relative;
  max-width: 60%;
  word-wrap: break-word;
  z-index: -1;
  background: rgba(185, 185, 185, 0.089);
  border-radius: 5px;
  text-align: left;
}
.myMessage {
  background: rgba(144, 162, 221, 0.164);
}
.post-box {
  color: var(--post-box-text-color);
  clear: both;
  margin-top: 10px;
  border-radius: 5px;
  margin-left: auto;
  margin-right: auto;
  min-width: 20%;
  max-width: 40%;
  padding: 8px;
  border: rgba(207, 35, 35, 0.589);
  background: rgba(54, 69, 87, 0.089);
  outline: none;
  font-size: 15px;
  text-align: center;
  transition: all 0.5s;
}
::placeholder {
  color: rgba(141, 141, 141, 0.589);
}
.post-box:focus {
  /* background: rgba(87, 87, 87, 0.027); */
  background: rgba(144, 162, 221, 0.164);
  min-width: 60%;
  max-width: 60%;
  text-align: left;
}
.post-box:focus::placeholder {
  transition: opacity 0.5s;
  color: transparent;
}
::-webkit-scrollbar {
  display: none;
}
.connection-text {
  position: fixed;
  padding: 10px;
  bottom: 0;
  right: 16px;
  text-align: right;
  font-size: 11px;
}
.live-Stream {
  position: fixed;
  padding: 10px;
  bottom: 0;
  right: 0;
  width: 11px;
  filter: hue-rotate(120deg) saturate(350%);
}
.dead-Stream {
  position: fixed;
  padding: 10px;
  bottom: 0;
  right: 0;
  width: 11px;
  animation: blinker 1s linear infinite;
}
@keyframes blinker {
  50% {
    opacity: 0;
  }
}
.list-enter-active,
.list-leave-active,
.list-move {
  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}
.list-enter {
  opacity: 0;
  transform: translateY(-50px);
}

.list-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.list-leave-active {
  position: absolute;
}

.list-leave-to {
  opacity: 0;
  transform: scaleY(0);
  transform-origin: center;
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
